import Cookies from 'js-cookie';
import customFetch from './customFetch';

const SESSION_TOKEN_KEY = 'session_token';

export const isAuthenticated = (): boolean => {
    return !!getToken();
};

export const getToken = (): string | null => {
    return Cookies.get(SESSION_TOKEN_KEY) ?? null
    // return localStorage.getItem(SESSION_TOKEN_KEY);
};

export const setToken = (token: string | null) => {
    if (token) {
        return Cookies.set(SESSION_TOKEN_KEY, token);
        // return localStorage.setItem(SESSION_TOKEN_KEY, token);
    } else {
        return Cookies.remove(SESSION_TOKEN_KEY);
        // localStorage.removeItem(SESSION_TOKEN_KEY);
    }
};

export const logout = async (): Promise<void> => {
    try {
        // Call the backend logout endpoint
        await customFetch('/v1/logout', {
            method: 'POST',
        });
    } catch (error) {
        console.error('Logout API call failed:', error);
    } finally {
        // Clear the token from cookies regardless of API call success
        setToken(null);
    }
};